/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Icon, Typo } from '@ers/ui/';
import { remove } from '../toasts.actions';

const ToastHooked = ({ toast }) => {
    const { type, message } = toast;
    const dispatch = useDispatch();
    const removeToast = useCallback(
        () => {
            dispatch(remove(toast));
        }
    );
    return <Toast type={type} message={message} onRemove={removeToast} />;
};
ToastHooked.propTypes = {
    toast: PropTypes.shape({
        type: PropTypes.string,
        message: PropTypes.string,
        id: PropTypes.string
    }).isRequired
};
export const Toast = ({ type, message, onRemove }) => (
    <div>
        <div className={cx('toast', `toast--${type}`)}>
            <Typo.Body className="with-all-paddings--4" variant={Typo.Variants[type.toUpperCase()]}>
                {message}
            </Typo.Body>
            <button type="button" className="with-margin--right-4" onClick={onRemove}>
                <Icon name="toast-close" />
            </button>
        </div>
    </div>
);

Toast.propTypes = {
    type: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    onRemove: PropTypes.func
};
Toast.defaultProps = {
    onRemove: () => null
};

export default ToastHooked;